import React, { useState, useEffect } from 'react';
import Modal from '../../../../../components/Modal';
import PropTypes from 'prop-types';
import DropDown from '../../../../../components/DropDown';
import { useGetAssignmentFoldersMutation } from '../../../../../features/authentication/authApiSlice';
import { useGetParentFoldersMutation } from '../../../../../features/authentication/assignApiSlice';
import { useAssignmentContext } from '../../../../assignments/context';
import CustomToast from '../../../../../components/Toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import ConfirmationModal from '../../../../../components/ConfirmationPopUp';
import { Tooltip } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import appConfig from '../../../../../app-config';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from '../../../../../features/authentication/authSlice';

const baseUrl = appConfig.apiBaseUrl;
const MoveMenuModal = ({ modalData, setModalData, fromMoreActions }) => {
  const token = useSelector(selectCurrentToken);
  const [getAllFolders] = useGetAssignmentFoldersMutation();
  const [getAllParents] = useGetParentFoldersMutation();
  const [selectedFolderId, setSelectedFolderId] = useState(-2);
  const [selectedParentId, setSelectedParentId] = useState(-1);
  const [allFolders, setAllFolders] = useState([]);
  const [allParents, setAllParents] = useState([]);
  const [newFolder, setNewFolder] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [confirmNotification, setConfirmNotification] = useState(false);
  const [folderCreated, setFolderCreated] = useState(new Date().getSeconds());
  const selectedAssignment = useAssignmentContext();
  const { assignmentId } = useAssignmentContext();

  const getAllFoldersAsync = async () => {
    try {
      const allFoldersResponse = await getAllFolders().unwrap();
      const folderArray = [];
      allFoldersResponse.map((item) => {
        const obj = {
          id: item.folderID,
          name: item.description
        };
        folderArray.push(obj);
      });
      const objData = {
        id: -2,
        name: 'New Folder'
      };
      const folderArrayResponse = [objData, ...folderArray];
      setAllFolders(folderArrayResponse);
      setSelectedFolderId(folderArrayResponse[0].id);
    } catch (error) {
      console.log(error);
    }
  };

  const getAllParentsAsync = async () => {
    try {
      const allParentsResponse = await getAllParents().unwrap();
      const parentArray = [];
      allParentsResponse.map((item) => {
        const obj = {
          id: item.folderID,
          name: item.description
        };
        parentArray.push(obj);
      });
      const objData = {
        id: -1,
        name: 'No Parent'
      };
      const parentArrayResponse = [objData, ...parentArray];
      setAllParents(parentArrayResponse);
      setSelectedParentId(parentArrayResponse[0].id);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelectFolder = (event) => {
    const folderId = parseInt(event.target.value);
    setSelectedFolderId(folderId);
  };

  const handleSelectParent = (event) => {
    const parentId = parseInt(event.target.value);
    setSelectedParentId(parentId);
  };

  const handleNewFolder = (event) => {
    const folderName = event.target.value;
    setNewFolder(folderName);
  };

  const moveConfirmationHandler = () => {
    if (selectedFolderId === -2) {
      if (newFolder !== '') {
        setConfirmNotification(true);
      } else {
        CustomToast('Please check new folder name is given', 'error');
      }
    } else {
      setConfirmNotification(true);
    }
  };

  const showConfirmation = (confirmMsg) => {
    if (confirmMsg) {
      if (!isLoading) {
        setIsLoading(true);
        moveDataHandler();
      }
    } else {
      setConfirmNotification(false);
    }
  };

  const moveDataHandler = async () => {
    let parentId = 0;
    if (selectedParentId === -1) {
      parentId = 0;
    } else {
      parentId = selectedParentId;
    }
    try {
      const options = {
        assignmentIds: !fromMoreActions
          ? selectedAssignment.assignedData?.map((item) => item.assignmentId)
          : [assignmentId],
        folderId: selectedFolderId,
        parentId: parentId,
        newFolder: newFolder
      };
      let url = baseUrl + '/Assignment/MoveAssignmentToFolder';
      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      };
      const response = await fetch(url, {
        headers,
        method: 'POST',
        body: JSON.stringify(options)
      });
      const result = response.status;
      const errorMsg = await response.text();
      if (result === 200) {
        CustomToast('Assignment Moved Successfully', 'success');
        resetMove();
        setConfirmNotification(false);
        setModalData(false);
        setFolderCreated(new Date().getSeconds());
        selectedAssignment.setAssignedDataStatus(new Date().getSeconds());
        selectedAssignment.setAssignedData([]);
        selectedAssignment.setAssignedName([]);
        selectedAssignment.setAssignmentId('');
        selectedAssignment.setAssignedCourseName([]);
        selectedAssignment.setFolderUpdateStatus(true);
        setIsLoading(false);
      } else {
        CustomToast(`${errorMsg}`, 'warning');
        setConfirmNotification(false);
        setIsLoading(false);
      }
    } catch (ex) {
      console.log(ex);
      setIsLoading(false);
    }
  };

  const resetMove = () => {
    setSelectedFolderId(-2);
    setSelectedParentId(-1);
    setNewFolder('');
  };

  useEffect(() => {
    getAllFoldersAsync();
    getAllParentsAsync();
  }, [folderCreated]);

  return (
    <Modal
      contentWidth="600px"
      isOpen={modalData}
      titleName={'Move Selected Assignments'}
      onClose={() => {
        resetMove();
        setModalData(false);
      }}>
      <div>
        <DropDown
          label="Folder to move to"
          value={allFolders}
          onChangeHandler={(e) => handleSelectFolder(e)}
          selectedValue={selectedFolderId}
        />
        {selectedFolderId === -2 && (
          <div className="py-3">
            <div className="align-items-center d-flex gap-5">
              <div className="d-flex">
                <div>
                  <DropDown
                    label="Parent folder"
                    value={allParents}
                    onChangeHandler={(e) => handleSelectParent(e)}
                    selectedValue={selectedParentId}
                  />
                </div>
                <OverlayTrigger
                  key="parent-folder-info"
                  placement="top"
                  overlay={
                    <Tooltip id="parent-tooltip" className="folder-info">
                      To move to a subfolder select a parent folder from the dropdown. If you wish
                      to create a new parent and subfolder you should enter the folder name as
                      parent/subfolder. The new parent folder will automatically be created. Only
                      one sublevel is allowed.
                    </Tooltip>
                  }>
                  <FontAwesomeIcon icon={faCircleQuestion} className="move-help" />
                </OverlayTrigger>
              </div>
              <div className="col-6">
                <label htmlFor="moveFolderName" className="form-label">
                  New folder name
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder=" "
                  name="moveFolderName"
                  id="moveFolderName"
                  onChange={(e) => handleNewFolder(e)}
                  required
                />
              </div>
            </div>
          </div>
        )}
        <div className="d-flex justify-content-end mt-3 gap-3 align-items-center">
          <button
            className="btn btn-castleGray print-btn"
            onClick={() => {
              resetMove();
              setModalData(false);
            }}>
            Cancel
          </button>
          <button className="btn btn-castleRed print-btn" onClick={moveConfirmationHandler}>
            Move
          </button>
        </div>
      </div>
      <ConfirmationModal
        isOpen={confirmNotification}
        onClose={() => showConfirmation(false)}
        onSave={() => showConfirmation(true)}
        contentWidth={'35%'}
        buttonPosition={'center'}
        content={
          'Are you sure that you want to move the checked assignments to the specified folder?'
        }
        cancelButton={'No'}
        confirmButton={'Yes'}
      />
    </Modal>
  );
};

MoveMenuModal.propTypes = {
  modalData: PropTypes.bool,
  setModalData: PropTypes.func,
  fromMoreActions: PropTypes.bool
};

export default MoveMenuModal;
